<template>
    <div>
        <topback title="Link KYC Partner" path="back"></topback>
        <div class="partner mt-6">
            <md-field>
                <md-field-item title="Partner" :content="ct_type" @click="showSelector" arrow solid />
                <div v-if="type==='freecharge' || type==='mobikwik' || type==='phonepe' || type === 'paytm'">
                    <aupiform :type="type" :ct="ct"></aupiform>
                </div>
                <div v-if="type === 'icicibank' || type === 'bharatpe'">
                    <accountform :type="type" :ct="ct"></accountform>
                </div>
            </md-field>
            <md-selector v-model="isSelectorShow" :data="ct_type_select" hide-title-bar large-radius is-check iconSize="lg"
                @choose="onSelectorChoose">
                <div class="selector-header" slot="header">
                    Choose a link authorization partner
                </div>
                <template slot-scope="{ option, index, selected }">
                    <div class="selector-item-body" :class="{ disabled: option.disabled, selected }">
                        <div class="selector-item-left">
                            <iconimg :name="option.value"></iconimg>
                        </div>
                        <div class="selector-item-content">
                            <p class="selector-item-title" v-text="option.text"></p>
                            <p class="selector-item-brief" v-text="`${option.describe}`"></p>
                        </div>
                    </div>
                </template>
                <div class="selector-footer" slot="footer">
                    Footer Slot
                </div>
            </md-selector>
        </div>

    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import { DropMenu } from 'mand-mobile'
import aupiform from '@/views/my/forms/aupiform'
import accountform from '@/views/my/forms/accountform'
import { getconfigs, getcollectiontool } from '@/request/api'


export default {
    name: 'linkkycpartner',
    components: {
        topback,
        iconimg,
        DropMenu,
        aupiform,
        accountform
    },

    data() {
        return {
            isSelectorShow: false,
            ct_type_select: [
                {
                    value: 'freecharge',
                    text: 'Freecharge',
                    describe: 'Freecharge offers digital payment and mobile recharge services in India.',
                },
                {
                    value: 'icicibank',
                    text: 'Icici Bank',
                    describe: 'Personal Banking & Netbanking Services Online.',
                },
                {
                    value: 'mobikwik',
                    text: 'Mobikwik',
                    describe: 'MobiKwik is an Indian digital payment platform.'
                },
                {
                    value: 'phonepe',
                    text: 'Phonepe',
                    describe: 'PhonePe is an Indian digital payment platform.',
                },
                {
                    value: 'bharatpe',
                    text: 'Bharatpe',
                    describe: 'Bharatpe is an Indian digital payment platform.',
                    disabled: true,
                },
                {
                    value: 'paytm',
                    text: 'Paytm',
                    describe: 'Paytm is an Indian digital payment platform.',
                    disabled: true,
                },
            ],
            ct_type: 'select the kyc partner',
            link_loading: false,
            type: "",
            ct_id: "",
            ct: null
        }
    },
    created() {
        this.$toast.loading("Loading...")
        this.ct_id = this.$route.params.kycid;
        if(this.ct_id) {
            this.get_ct_detail();
        }
        getconfigs({ keys: 'open_account_type' }).then(res => {
          if (res.code === 200) {
            this.$toast.hide();
            let opentype = JSON.parse(res.data.open_account_type);
            for (let i = 0; i < this.ct_type_select.length; i++) {
                this.ct_type_select[i].disabled = !opentype[this.ct_type_select[i].value];
            }
          } else {
            this.$toast.failed("The Kyc link is not open yet")
          }
        })
    },
    methods: {
        get_ct_detail() {
            getcollectiontool({id: this.ct_id}).then(res=>{
                if(res.code === 200) {
                    this.type = res.data.type;
                    let obj = this.ct_type_select.find(item => item.value === this.type);
                    let text = obj ? obj.text : 'N/A';
                    this.ct_type = text;
                    this.ct = res.data;
                }
            })
        },
        showSelector() {
            this.isSelectorShow = true
        },
        onSelectorChoose({ value, text }) {
            this.ct_type = text
            this.type = value;
        },
    }
}

</script>
<style lang="stylus" scoped>
.partner
  .selector-header, .selector-footer
    padding 15px 40px
    font-size 16px
    color #ccc
  .selector-item-body
    display flex
    align-items center
    &.selected
      .selector-item-content
        color #2f86f6
    &.disabled
      opacity .3
    .selector-item-left
      flex-shrink 0
      margin-right 32px
      .holder
        display block
        width 88px
        height 88px
        border-radius 44px
        background-color #e6e6e6
        font-size 32px
        font-weight 500
        color #2f86f6
        text-align center
        line-height 88px
    .selector-item-content
      flex 1
      color #111a34
      font-size 32px
      line-height 1.2
      .selector-item-title
        line-height 1.2
      .selector-item-brief
        color #858b9c
        font-size 24px
        line-height 1.4
        margin-top 8px
</style>



// WEBPACK FOOTER //
// src/views/my/linkkycpartner.vue